import {
    WemapPinpoint,
    WemapPinpointId,
} from '../../../../design-system/components/wemap/types/Wemap';
import {
    createWemapRegionPinpoint,
    hashedPinpointId,
    highlightedPinpointId,
} from '../../../../design-system/components/wemap/utilities/pinpoints';
import { GeolocationBoundaries } from '../../../../domains/Geolocation/Geolocation';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { DestinationTypeRegion } from '../../../destination/domain/types/destination';
import { Region, RegionId } from '../types/region';

type RegionPinpointStyle = NonNullable<WemapPinpoint['geo_entity_shape']>['properties'];

/** Deterministic numeric pinpoint id for a region, derived from its uuid (see pinpoints.ts). */
export function regionPinpointId(regionId: RegionId): WemapPinpointId {
    return hashedPinpointId(regionId);
}

export function formatRegionAsWemapPinpoint(
    region: PickDomain<Region, 'id' | 'name'>,
    boundaries: GeolocationBoundaries,
    style?: RegionPinpointStyle,
    isHighlighted = false,
): WemapPinpoint {
    const id = regionPinpointId(region.id);
    return createWemapRegionPinpoint({
        id: isHighlighted ? highlightedPinpointId(id) : id,
        name: region.name,
        boundaries,
        style,
    });
}

export function formatDestinationRegionAsWemapPinpoint(
    destination: PickDomain<DestinationTypeRegion, 'id' | 'name'>,
    boundaries: GeolocationBoundaries,
    style?: RegionPinpointStyle,
    isHighlighted = false,
): WemapPinpoint {
    return createWemapRegionPinpoint({
        id: isHighlighted ? highlightedPinpointId(destination.id) : destination.id,
        name: destination.name,
        boundaries,
        style,
    });
}
